import { PageViewOptions, TrackOptions } from 'ia-react-core';
import { LanguageServices } from 'omni-package-react-core';
import { DataLayerArgs } from 'react-gtm-module';
import { AnalyticsValues } from '../interfaces/AnalyticsValues';

export function buildPageViewDataLayer(options: PageViewOptions<AnalyticsValues>): DataLayerArgs {
  const newOptions: any = { ...options };
  const lob = options.pageValues?.lob ?? undefined;
  newOptions.history_location = newOptions.location;
  delete newOptions.location;
  delete newOptions.pageValues?.lob;
  return {
    dataLayer: {
      ...newOptions,
      event: 'Pageview',
      page: {
        language: LanguageServices.getLanguage(),
        environment: process.env.REACT_APP_ANALYTICS_ENV === 'prod' ? 'prod' : 'pre-prod',
        lob,
        title: document.title,
      },
      dom_location: {
        ...window.location,
      },
    },
  };
}

export function buildTrackDataLayer(options: TrackOptions<AnalyticsValues>): DataLayerArgs {
  let event = 'unknown';
  if (options.event) { event = options.event.type; }
  const lob = options.values?.lob ?? undefined;
  delete options.values?.lob;

  return {
    dataLayer: {
      ...options,
      event,
      page: {
        language: LanguageServices.getLanguage(),
        environment: process.env.REACT_APP_ANALYTICS_ENV === 'prod' ? 'prod' : 'pre-prod',
        lob,
        title: document.title,
      },
      dom_location: {
        ...window.location,
      },
    },
  };
}
